import React, { useEffect } from 'react'
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"
import useAdminUsersInfo from "Pages/Admin/Users/@hooks/useInfo"
import { userErrorRegistry, userPayload } from "Pages/Admin/Users/@signals"

import { object, string } from "yup"
import { useValidatorSeeker } from "@app"
import { BACKEND_APIS } from "@constants"

export default function UserTimeZoneField() {

	const { userTZ, setUserTZInfo } = useAdminUsersInfo(userPayload.peek()?.userConfig?.userTZ, "userTZ", "userConfig")

	const { errors, isValid } = useValidatorSeeker(
		{ userTZ: userTZ },
		object({
			userTZ: string().required('Must provide a Time Zone')
		})
	)

	useEffect(() => {
		userErrorRegistry.value = { ...userErrorRegistry.peek(), userTZ: isValid }
	}, [isValid])

	return <AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/date/options/timezone`}
		value={userTZ}
		label="User Time Zone"
		placeholder="User Time Zone"
		onChange={e => setUserTZInfo(e.target.value)}
		error={errors?.userTZ}
	/>
}